export default __webpack_public_path__ + "static/media/ikonica-on.dffddeb3.png";